import { isPreorderable } from './isPreorderable';

export function isPreorderEligibleBySelectedProduct(
  product,
  selectionStateByProductIndex
) {
  if (!isPreorderable(product)) {
    return false;
  }

  if (product.bundleComponentProducts) {
    // if any item in the bundle is flagged as a preorder item,
    // go ahead and display the preorder CTA
    return selectionStateByProductIndex.some(({ selectedSKU }) => {
      return selectedSKU ? selectedSKU.isPreorder : false;
    });
  }

  return selectionStateByProductIndex[0].selectedSKU
    ? selectionStateByProductIndex[0].selectedSKU.isPreorder
    : false;
}
